module.exports = __webpack_public_path__ + "media/toolkits/HVAC-phones-overlay-599e55ce.png";